<cerrix-button
    [buttonType]="buttonType"
    [primaryColor]="primaryColor"
    [secondaryColor]="secondaryColor"
    [buttonSize]="buttonSize"
    [waitingOnResult]="waitingOnResult"
    [showResultText]="showResultText"
    [disabled]="disabled"
>
    <span button-text>
        @if (iconPosition === "left") {
            <mat-icon [svgIcon]="icon" />
        }
        {{ text }}
        @if (iconPosition === "right") {
            <mat-icon [svgIcon]="icon" />
        }
    </span>
    <span result-text>
        @if (iconPosition === "left") {
            <mat-icon [svgIcon]="resultIcon" />
        }
        {{ resultText }}
        @if (iconPosition === "right") {
            <mat-icon [svgIcon]="resultIcon" />
        }
    </span>
</cerrix-button>
